import { COMPANY_SHORT, ABOUT_IMAGE_URL, PUBLIC_INFO } from '../constants';

function AboutSection() {
  return (
    <section id="about" className="bg-white">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div className="relative">
          <div
            aria-hidden
            className="absolute -left-3 -top-3 h-full w-full rounded-[2.25rem] bg-blush"
          />
          <div className="relative overflow-hidden rounded-[2.25rem] border border-line bg-plum shadow-soft">
            <img
              src={ABOUT_IMAGE_URL}
              alt={`Editorial image representing ${COMPANY_SHORT}`}
              className="h-[460px] w-full object-cover opacity-95"
            />
            <div
              aria-hidden
              className="absolute inset-0 bg-gradient-to-t from-plum/85 via-plum/10 to-transparent"
            />
            <div className="absolute inset-x-0 bottom-0 p-7 text-petal">
              <p className="text-[11px] font-black uppercase tracking-[0.24em] text-petal/70">
                Editorial Image
              </p>
              <p className="font-display mt-1 text-2xl">A public directory profile</p>
            </div>
          </div>
        </div>

        <div>
          <p className="text-xs font-black uppercase tracking-[0.22em] text-rose">
            About the profile
          </p>
          <h2 className="font-display mt-3 text-4xl text-plum sm:text-5xl">
            A quiet introduction to {COMPANY_SHORT}.
          </h2>
          <p className="mt-5 leading-8 text-ink/75">
            This page exists as a public-safe directory profile. It keeps only
            what a community member would expect to find on a calm, modern
            profile page.
          </p>
          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {PUBLIC_INFO.map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-line bg-petal/40 px-5 py-4"
              >
                <p className="text-[11px] font-black uppercase tracking-[0.2em] text-rose">
                  {item.label}
                </p>
                <p className="mt-1.5 font-semibold text-plum">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
